import { Component, ViewEncapsulation } from '@angular/core';
import { DialogContentBase, DialogRef } from '@progress/kendo-angular-dialog';

@Component({
    selector: 'app-dialog-connection-error',
    template: `
        <div class="flex flex-col items-center gap-6 px-8 py-10 text-center">
            <div class="flex h-20 w-20 items-center justify-center rounded-full bg-orange-100 text-orange-500">
                <ng-icon name="faSolidTriangleExclamation" size="2.5rem" />
            </div>
            <div class="flex flex-col gap-2">
                <h2 class="text-xl font-semibold text-gray-800" translate>Connection lost</h2>
                <p class="max-w-xs text-sm text-gray-500" translate>
                    The connection to the server was lost or a new version is being deployed. Please check your
                    connection.
                </p>
            </div>
            <div class="flex gap-3">
                <app-button variant="primary" icon="faSolidArrowsRotate" (clicked)="retry()">
                    {{ 'Refresh' | translate }}
                </app-button>
                <app-button variant="secondary" (clicked)="dialog.close(true)">
                    {{ 'Ok' | translate }}
                </app-button>
            </div>
        </div>
    `,
    encapsulation: ViewEncapsulation.None
})
export class DialogConnectionErrorComponent extends DialogContentBase {
    constructor(public override dialog: DialogRef) {
        super(dialog);
    }

    retry() {
        window.location.reload();
    }
}
